
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Policies",
      function () {
        return require("private-next-pages/Policies/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Policies"])
      });
    }
  